/* PDP guidance — complements Buy Box, quiz inline, modal 6 étapes */

(function () {
  if (window.__lcfPdpGuidance) return;
  window.__lcfPdpGuidance = true;

  var TWO_PERSON_MIN = 220;
  var OREILLER_MAP = { firm: 'auron', medium: 'avoriaz', soft: 'tignes' };
  var STEP_LABELS = {
    step1: 'Objectif',
    step2: 'Contexte',
    step3: 'Couette',
    step4: 'Couette',
    step5: 'Oreiller',
    step6: 'Oreiller'
  };

  function money(cents) {
    var formatted;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      formatted = Shopify.formatMoney(cents, window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat);
    } else {
      formatted = (Number(cents) / 100).toFixed(0) + ' €';
    }
    return euroAfter(formatted);
  }

  function euroAfter(value) {
    var text = String(value == null ? '' : value);
    if (text.indexOf('€') === -1) return text;
    var amount = text.replace(/€/g, '').replace(/\s+/g, ' ').trim();
    if (!amount) return text;
    return amount + ' €';
  }

  function rewriteEuroPrices(root) {
    if (!document.querySelector('.product--immersive')) return;
    var scope = root || document;
    var nodes = scope.querySelectorAll('.product--immersive sale-price, .product--immersive compare-at-price');
    nodes.forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.parentElement && node.parentElement.closest('.sr-only')) continue;
        var next = euroAfter(node.textContent);
        if (next !== node.textContent) node.textContent = next;
      }
    });
  }

  function parseWidth(variant) {
    if (!variant) return 0;
    var src = [variant.title, variant.name, variant.option1, variant.option2, variant.option3]
      .filter(Boolean)
      .join(' ');
    var match = String(src).match(/(\d{2,3})\s*[x×]/i);
    return match ? parseInt(match[1], 10) : 0;
  }

  function readCatalog(root) {
    var node = (root && root.querySelector('[data-personal-shopper-catalog]')) ||
      document.querySelector('[data-personal-shopper-catalog]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function flattenCatalog(catalog) {
    var map = {};
    if (!catalog) return map;
    ['couettes', 'oreillers'].forEach(function (group) {
      Object.keys(catalog[group] || {}).forEach(function (key) {
        map[catalog[group][key].handle] = catalog[group][key];
        map[key] = catalog[group][key];
      });
    });
    return map;
  }

  /* ——— Complements ——— */
  function updateComplementsQty(box, variant) {
    var family = (box.getAttribute('data-family') || '').toLowerCase();
    var qty = 1;
    if (family === 'couette') {
      qty = parseWidth(variant) >= TWO_PERSON_MIN ? 2 : 1;
    }
    box.setAttribute('data-complement-qty', String(qty));
    var label = box.querySelector('[data-complement-qty-label]');
    var noun = box.getAttribute('data-noun') || 'oreiller';
    var nounPlural = box.getAttribute('data-noun-plural') || 'oreillers';
    if (label) {
      label.textContent = qty > 1 ? qty + ' ' + nounPlural : '1 ' + noun;
    }
    refreshCheckLabel(box);
  }

  function refreshCheckLabel(box) {
    var selected = box.querySelector('[data-complement-item].is-selected');
    var text = box.querySelector('[data-complement-check-text]');
    if (!text) return;
    var qty = parseInt(box.getAttribute('data-complement-qty'), 10) || 1;
    var noun = box.getAttribute('data-noun') || 'oreiller';
    var nounPlural = box.getAttribute('data-noun-plural') || 'oreillers';
    var name = selected ? selected.getAttribute('data-short') : '';
    var price = selected ? parseInt(selected.getAttribute('data-price'), 10) : 0;
    var word = qty > 1 ? nounPlural : noun;
    var prefix = qty > 1 ? 'Ajouter aussi ' + qty + ' ' + word : 'Ajouter aussi 1 ' + word;
    if (name) prefix += ' ' + name;
    if (price) prefix += ' — ' + money(price * qty);
    text.textContent = prefix;
    updateAtcPrice(box);
  }

  function formQuantity(formId) {
    var form = formId ? document.getElementById(formId) : document.querySelector('form[is="product-form"]');
    var qty = form && form.querySelector('[name="quantity"]');
    var n = qty ? parseInt(qty.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function toCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'object' && value.amount != null) return toCents(value.amount);
    var raw = String(value).trim().replace(/\s/g, '').replace(',', '.');
    var n = parseFloat(raw);
    if (!isFinite(n) || n <= 0) return 0;
    if (raw.indexOf('.') !== -1 && n < 100000) return Math.round(n * 100);
    return Math.round(n);
  }

  function activeProductForm(box) {
    var formId = box && box.getAttribute('data-form');
    return (formId && document.getElementById(formId)) ||
      document.querySelector('.product--immersive form[is="product-form"]') ||
      document.querySelector('form[is="product-form"]');
  }

  function selectedVariantId(form) {
    var idInput = form && form.querySelector('[name="id"]');
    return idInput && idInput.value ? String(idInput.value) : '';
  }

  function variantPriceFromScript(variantId) {
    var scripts = document.querySelectorAll('variant-picker script[data-variant]');
    for (var i = 0; i < scripts.length; i += 1) {
      try {
        var v = JSON.parse(scripts[i].textContent);
        if (!v) continue;
        if (!variantId || String(v.id) === String(variantId)) return toCents(v.price);
      } catch (e) {}
    }
    return 0;
  }

  function variantPriceFromAlmaData(variantId) {
    var data = window.ALMA_PRODUCT_DATA;
    if (!data) return 0;
    if (variantId && data.variants && data.variants.length) {
      for (var i = 0; i < data.variants.length; i += 1) {
        if (String(data.variants[i].id) === String(variantId)) return toCents(data.variants[i].price);
      }
    }
    return 0;
  }

  function variantPriceFromPicker(form, variantId) {
    if (!form || !variantId) return 0;
    var radio = form.querySelector('[data-variant-id="' + variantId + '"]');
    if (radio) {
      var fromRadio = toCents(radio.getAttribute('data-price') || radio.getAttribute('data-variant-price'));
      if (fromRadio) return fromRadio;
    }
    var option = document.querySelector('[data-lcf-sticky-size] option[value="' + variantId + '"]');
    if (option) return toCents(option.getAttribute('data-price'));
    return 0;
  }

  function liveMainPriceCents(box) {
    var form = activeProductForm(box);
    var variantId = selectedVariantId(form);
    var main = variantPriceFromScript(variantId) ||
      variantPriceFromAlmaData(variantId) ||
      variantPriceFromPicker(form, variantId);
    if (!main && box) main = toCents(box.getAttribute('data-main-price'));
    if (box && main) box.setAttribute('data-main-price', String(main));
    return main;
  }

  function currentCheckoutCents(box) {
    box = box || document.querySelector('[data-lcf-complements]');
    var form = activeProductForm(box);
    var qty = formQuantity(form && form.id);
    var main = liveMainPriceCents(box);
    var extra = 0;
    if (box) {
      var check = box.querySelector('[data-complement-check]');
      if (check && check.checked) {
        var selected = box.querySelector('[data-complement-item].is-selected');
        var unit = selected ? toCents(selected.getAttribute('data-price')) : 0;
        extra = unit * (parseInt(box.getAttribute('data-complement-qty'), 10) || 1);
      }
    }
    return (main * qty) + extra;
  }

  function almaPlans() {
    var raw = window.ALMA_FEE_PLANS;
    if (!raw) return undefined;
    var data = raw;
    if (typeof raw === 'string') {
      try { data = JSON.parse(raw); } catch (e) { return undefined; }
    }
    var plans = [];
    Object.keys(data).forEach(function (key) {
      var p = data[key];
      if (!p || String(p.is_enabled).toLowerCase() !== 'true') return;
      var parts = key.split('_');
      plans.push({
        installmentsCount: parseInt(parts[1], 10) || 1,
        deferredDays: parseInt(parts[2], 10) || 0,
        deferredMonths: parseInt(parts[3], 10) || 0,
        minAmount: Number(p.min_amount || p.min_purchase_amount) || 0,
        maxAmount: Number(p.max_amount || p.max_purchase_amount) || 0
      });
    });
    return plans.length ? plans : undefined;
  }

  function selectedAlmaPlan() {
    var el = document.querySelector('#alma-widget [aria-selected="true"]');
    if (!el) return null;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (/payer maintenant|pay now/i.test(t)) return 1;
    var n = parseInt(t, 10);
    return isNaN(n) ? null : n;
  }

  function almaMerchantId() {
    if (window.ALMA_MERCHANT_ID) return window.ALMA_MERCHANT_ID;
    var node = document.querySelector('[data-alma-merchant-id], #alma-widget[data-merchant-id]');
    if (node) return node.getAttribute('data-alma-merchant-id') || node.getAttribute('data-merchant-id');
    return '';
  }

  function almaMode() {
    if (window.Alma && Alma.ApiMode && Alma.ApiMode.LIVE) return Alma.ApiMode.LIVE;
    return 'live';
  }

  var almaSyncTimer = null;
  var almaLastCents = -1;
  var almaForce = false;
  var almaWriting = false;

  function renderAlmaWidget(cents) {
    if (!cents || cents < 1) return;
    var merchant = almaMerchantId();
    if (!window.Alma || !Alma.Widgets || !merchant) return;
    var widget = document.getElementById('alma-widget');
    if (!widget) return;
    try {
      almaWriting = true;
      window.ALMA_PRODUCT_DATA = window.ALMA_PRODUCT_DATA || {};
      window.ALMA_PRODUCT_DATA.price = cents;
      widget.setAttribute('data-purchase-amount', String(cents));
      window.__lcfAlmaController = window.__lcfAlmaController || Alma.Widgets.initialize(merchant, almaMode());
      var opts = {
        container: '#alma-widget',
        locale: document.documentElement.lang || 'fr',
        purchaseAmount: cents,
        hideIfNotEligible: !(window.ALMA_DISPLAY_WIDGET_NOT_ELIGIBLE === true || window.ALMA_DISPLAY_WIDGET_NOT_ELIGIBLE === 'true'),
        hideBorder: true,
        monochrome: window.ALMA_WIDGET_MONOCHROME !== false && window.ALMA_WIDGET_MONOCHROME !== 'false'
      };
      var plans = almaPlans();
      if (plans) opts.plans = plans;
      var suggested = selectedAlmaPlan();
      if (suggested) opts.suggestedPaymentPlan = suggested;
      window.__lcfAlmaController.add(Alma.Widgets.PaymentPlans, opts);
      almaLastCents = cents;
      almaForce = false;
      setTimeout(function () { almaWriting = false; }, 400);
    } catch (err) {
      almaWriting = false;
    }
  }

  function syncAlmaAmount(cents, force) {
    var amount = typeof cents === 'number' ? cents : currentCheckoutCents(document.querySelector('[data-lcf-complements]'));
    if (!amount) return;
    if (force) almaForce = true;
    if (!almaForce && amount === almaLastCents) return;
    window.ALMA_PRODUCT_DATA = window.ALMA_PRODUCT_DATA || {};
    window.ALMA_PRODUCT_DATA.price = amount;
    clearTimeout(almaSyncTimer);
    almaSyncTimer = setTimeout(function () {
      if (window.Alma && Alma.Widgets) {
        renderAlmaWidget(amount);
        return;
      }
      var tries = 0;
      var wait = setInterval(function () {
        tries += 1;
        if (window.Alma && Alma.Widgets) {
          clearInterval(wait);
          renderAlmaWidget(amount);
        } else if (tries > 40) {
          clearInterval(wait);
        }
      }, 200);
    }, 60);
  }

  function observeAlmaWidget() {
    if (window.__lcfAlmaObserved) return;
    var widget = document.getElementById('alma-widget');
    if (!widget) return;
    window.__lcfAlmaObserved = true;
    var timer = null;
    var observer = new MutationObserver(function () {
      if (almaWriting) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var next = currentCheckoutCents();
        if (next && next !== almaLastCents) syncAlmaAmount(next, true);
      }, 280);
    });
    observer.observe(widget, { childList: true, subtree: true });
  }

  function updateAtcPrice(box) {
    if (!box) return;
    var formId = box.getAttribute('data-form');
    var mainPrice = parseInt(box.getAttribute('data-main-price'), 10) || 0;
    var check = box.querySelector('[data-complement-check]');
    var extra = 0;
    if (check && check.checked) {
      var selected = box.querySelector('[data-complement-item].is-selected');
      var unit = selected ? parseInt(selected.getAttribute('data-price'), 10) : 0;
      var qty = parseInt(box.getAttribute('data-complement-qty'), 10) || 1;
      extra = unit * qty;
    }
    var total = mainPrice + extra;
    var prefix = box.getAttribute('data-atc-prefix') || 'Ajouter au panier';
    var label = prefix + ' - ' + money(total);

    var buttons = [];
    if (formId) {
      var form = document.getElementById(formId);
      if (form) {
        Array.prototype.forEach.call(form.querySelectorAll('button[type="submit"]'), function (btn) {
          buttons.push(btn);
        });
      }
      Array.prototype.forEach.call(document.querySelectorAll('button[type="submit"][form="' + formId + '"]'), function (btn) {
        buttons.push(btn);
      });
    }

    buttons.forEach(function (btn) {
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      var wrap = btn.querySelector('.text-with-icon');
      if (wrap) {
        var replaced = false;
        Array.prototype.forEach.call(wrap.childNodes, function (node) {
          if (node.nodeType === 3 && node.textContent.trim()) {
            node.textContent = ' ' + label;
            replaced = true;
          }
        });
        if (!replaced) wrap.appendChild(document.createTextNode(' ' + label));
        return;
      }
      btn.textContent = label;
    });

    var stickyPrice = document.querySelector('.product-quick-add--immersive sale-price');
    if (stickyPrice) {
      Array.prototype.forEach.call(stickyPrice.childNodes, function (node) {
        if (node.nodeType === 3 && node.textContent.trim()) node.textContent = money(total);
      });
    }

    syncAlmaAmount(currentCheckoutCents(box));
  }

  var selectedHandle = null;
  var complementChecked = false;
  var addingToCart = false;

  function selectComplement(box, handle, options) {
    options = options || {};
    selectedHandle = handle;
    box.querySelectorAll('[data-complement-item]').forEach(function (el) {
      var on = el.getAttribute('data-handle') === handle;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var check = box.querySelector('[data-complement-check]');
    if (check && handle && options.check !== false) {
      check.checked = true;
      complementChecked = true;
    }
    refreshCheckLabel(box);
    updateAtcPrice(box);
  }

  function initComplements(box) {
    if (!box || box.dataset.ready === 'true') return;
    box.dataset.ready = 'true';

    var variantTitle = box.getAttribute('data-current-variant') || '';
    updateComplementsQty(box, { title: variantTitle });

    var first = box.querySelector('[data-complement-item]');
    var restore = selectedHandle && box.querySelector('[data-complement-item][data-handle="' + selectedHandle + '"]');
    if (restore) selectComplement(box, selectedHandle, { check: false });
    else if (first) selectComplement(box, first.getAttribute('data-handle'), { check: false });
    var check = box.querySelector('[data-complement-check]');
    if (check) check.checked = !!complementChecked;
    updateAtcPrice(box);
  }

  document.addEventListener('variant:change', function (event) {
    var formEl = event.target;
    var formId = formEl && formEl.getAttribute ? formEl.getAttribute('id') : '';
    var variant = event.detail && event.detail.variant;
    document.querySelectorAll('[data-lcf-complements]').forEach(function (box) {
      var boxForm = box.getAttribute('data-form');
      if (boxForm && formId && boxForm !== formId) return;
      updateComplementsQty(box, variant);
      if (variant && typeof variant.price !== 'undefined') {
        box.setAttribute('data-main-price', String(toCents(variant.price) || variant.price));
      }
      updateAtcPrice(box);
    });
    if (variant && variant.id) {
      document.querySelectorAll('[data-lcf-sticky-size]').forEach(function (sel) {
        var next = String(variant.id);
        if (sel.value !== next) sel.value = next;
      });
    }
    if (!document.querySelector('[data-lcf-complements]')) {
      syncAlmaAmount(currentCheckoutCents(), true);
    } else {
      setTimeout(function () { syncAlmaAmount(currentCheckoutCents(), true); }, 120);
    }
    setTimeout(rewriteEuroPrices, 0);
  });

  document.addEventListener('click', function (event) {
    var item = event.target.closest('[data-complement-item]');
    if (item) {
      event.preventDefault();
      var box = item.closest('[data-lcf-complements]');
      if (box) selectComplement(box, item.getAttribute('data-handle'));
      return;
    }

    var quizOpen = event.target.closest('[data-complement-quiz]');
    if (quizOpen) {
      event.preventDefault();
      var box = quizOpen.closest('[data-lcf-complements]');
      var inline = box && box.querySelector('[data-ps-inline]');
      if (inline) openInlineQuiz(inline, box);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.getAttribute && event.target.getAttribute('name') === 'quantity') {
      var qtyBox = document.querySelector('[data-lcf-complements]');
      if (qtyBox) updateAtcPrice(qtyBox);
      else syncAlmaAmount(currentCheckoutCents(), true);
      return;
    }

    if (event.target && event.target.getAttribute && event.target.getAttribute('name') === 'id') {
      var idBox = document.querySelector('[data-lcf-complements]');
      if (idBox) updateAtcPrice(idBox);
      else syncAlmaAmount(currentCheckoutCents(), true);
      return;
    }

    var stickySize = event.target.closest('[data-lcf-sticky-size]');
    if (stickySize) {
      var optionValue = stickySize.selectedOptions[0] && stickySize.selectedOptions[0].getAttribute('data-option');
      var variantId = stickySize.value;
      var matched = false;
      document.querySelectorAll('variant-picker input[type="radio"]').forEach(function (radio) {
        var label = radio.closest('label');
        var name = (label ? label.textContent : '').replace(/\s+/g, ' ').trim();
        if (optionValue && name === optionValue) {
          matched = true;
          if (!radio.checked) radio.click();
        }
      });
      if (!matched && variantId) {
        var form = document.getElementById(stickySize.getAttribute('form'));
        var idInput = form && form.querySelector('[name="id"]');
        if (idInput && String(idInput.value) !== String(variantId)) {
          idInput.value = variantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      return;
    }

    var check = event.target.closest('[data-complement-check]');
    if (!check) return;
    var box = check.closest('[data-lcf-complements]');
    if (!box) return;
    if (check.checked && !box.querySelector('[data-complement-item].is-selected')) {
      var first = box.querySelector('[data-complement-item]');
      if (first) selectComplement(box, first.getAttribute('data-handle'));
    }
    complementChecked = !!check.checked;
    updateAtcPrice(box);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;

    var box = document.querySelector('[data-lcf-complements][data-form="' + form.id + '"]');
    var check = box && box.querySelector('[data-complement-check]');
    if (!box || !check || !check.checked) return;

    var selected = box.querySelector('[data-complement-item].is-selected');
    var compId = selected && parseInt(selected.getAttribute('data-variant-id'), 10);
    if (!compId) return;
    if (addingToCart) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    addingToCart = true;

    var mainId = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var compQty = parseInt(box.getAttribute('data-complement-qty'), 10) || 1;
    var submitButtons = Array.from(form.elements).filter(function (el) { return el.type === 'submit'; });
    Array.prototype.forEach.call(document.querySelectorAll('button[type="submit"][form="' + form.id + '"]'), function (btn) {
      if (submitButtons.indexOf(btn) === -1) submitButtons.push(btn);
    });

    submitButtons.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });

    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          { id: Number(mainId && mainId.value), quantity: mainQty },
          { id: compId, quantity: compQty }
        ],
        sections: sectionsToBundle.join(','),
        sections_url: root + 'variants/' + (mainId && mainId.value)
      })
    }).then(function (response) {
      return response.json().then(function (json) {
        return { ok: response.ok, json: json };
      });
    }).then(function (result) {
      if (!result.ok) {
        addingToCart = false;
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: result.json.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      return fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          addingToCart = false;
          submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
          cart.sections = result.json.sections;
          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: result.json.items || [result.json], cart: cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart }
          }));
        });
    }).catch(function () {
      addingToCart = false;
      submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
    });
  }, true);

  /* ——— Inline quiz ——— */
  function openInlineQuiz(inline, box) {
    inline.hidden = false;
    inline.classList.add('is-open');
    inline.dataset.step = '1';
    inline.dataset.family = (box.getAttribute('data-family') || '').toLowerCase();
    renderInlineStep(inline, box, 1);
    var back = inline.querySelector('[data-ps-inline-back]');
    if (back) back.hidden = true;
  }

  function closeInlineQuiz(inline) {
    inline.hidden = true;
    inline.classList.remove('is-open');
    inline.dataset.step = '1';
    var back = inline.querySelector('[data-ps-inline-back]');
    if (back) back.hidden = true;
  }

  function renderInlineStep(inline, box, step) {
    var family = inline.dataset.family;
    var mount = inline.querySelector('[data-ps-step="' + step + '"]');
    inline.querySelectorAll('[data-ps-step]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-ps-step') === String(step));
    });
    if (!mount) return;

    if (family === 'couette') {
      mount.innerHTML =
        '<p class="ps-inline__q">Quel maintien recherchez-vous&nbsp;?</p>' +
        '<div class="ps-inline__opts">' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="firm">Ferme</button>' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="medium">Mi-ferme</button>' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="soft">Moelleux</button>' +
        '</div>';
      return;
    }

    if (step === 1) {
      mount.innerHTML =
        '<p class="ps-inline__q">Quelle sensation vous fait rêver&nbsp;?</p>' +
        '<div class="ps-inline__opts">' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="synthetic">Synthétique recyclé</button>' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="natural">Duvet naturel</button>' +
        '</div>';
    } else {
      mount.innerHTML =
        '<p class="ps-inline__q">Température de la chambre&nbsp;?</p>' +
        '<div class="ps-inline__opts">' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="warm">Autour de 18°C</button>' +
          '<button type="button" class="ps-inline__opt" data-ps-inline-answer="cool">Plutôt fraîche</button>' +
        '</div>';
    }
  }

  function finishInline(inline, box, key) {
    var catalog = readCatalog(box);
    var map = flattenCatalog(catalog);
    var product = map[key];
    if (product) selectComplement(box, product.handle);
    inline.hidden = true;
    inline.classList.remove('is-open');
  }

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-ps-inline-close]');
    if (closer) {
      event.preventDefault();
      var inlineClose = closer.closest('[data-ps-inline]');
      if (inlineClose) closeInlineQuiz(inlineClose);
      return;
    }

    var back = event.target.closest('[data-ps-inline-back]');
    if (back) {
      var inline = back.closest('[data-ps-inline]');
      var box = inline && inline.closest('[data-lcf-complements]');
      if (!inline || !box) return;
      inline.dataset.step = '1';
      renderInlineStep(inline, box, 1);
      back.hidden = true;
      return;
    }

    var opt = event.target.closest('[data-ps-inline-answer]');
    if (!opt) return;
    var inline = opt.closest('[data-ps-inline]');
    var box = inline && inline.closest('[data-lcf-complements]');
    if (!inline || !box) return;

    var answer = opt.getAttribute('data-ps-inline-answer');
    var family = inline.dataset.family;

    if (family === 'couette') {
      finishInline(inline, box, OREILLER_MAP[answer]);
      return;
    }

    if (inline.dataset.step === '1') {
      if (answer === 'synthetic') {
        finishInline(inline, box, 'chamonix');
        return;
      }
      inline.dataset.step = '2';
      renderInlineStep(inline, box, 2);
      var backBtn = inline.querySelector('[data-ps-inline-back]');
      if (backBtn) backBtn.hidden = false;
      return;
    }

    finishInline(inline, box, answer === 'warm' ? 'megeve' : 'courchevel');
  });

  /* ——— Modal 6 étapes ——— */
  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function initModal(modal) {
    if (!modal || modal.dataset.ready === 'true') return;
    modal.dataset.ready = 'true';
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var catalog = readCatalog(document);
    var products = flattenCatalog(catalog);
    var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-ps-panel]'));
    var progressEl = modal.querySelector('[data-ps-progress]');
    var resultsEl = modal.querySelector('[data-ps-results]');
    var resultHeading = modal.querySelector('[data-ps-result-heading]');
    var resultSub = modal.querySelector('[data-ps-result-sub]');
    var step5Title = modal.querySelector('[data-ps-step5-title]');
    var state = { parcours: null, statut_lit: null, choix_couette: null, choix_oreiller_1: null, choix_oreiller_2: null, history: [] };

    function resetState() {
      state.parcours = null;
      state.statut_lit = null;
      state.choix_couette = null;
      state.choix_oreiller_1 = null;
      state.choix_oreiller_2 = null;
      state.history = [];
    }

    function showPanel(stepId, skipHistory) {
      var current = modal.querySelector('[data-ps-panel].is-active');
      if (current && !skipHistory && current.getAttribute('data-ps-panel') !== stepId) {
        state.history.push(current.getAttribute('data-ps-panel'));
      }
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-ps-panel') === stepId);
      });
      if (stepId === 'step5' && step5Title) {
        step5Title.innerHTML = state.statut_lit === 'duo'
          ? 'Pour vous, quel confort de maintien recherchez-vous&nbsp;?'
          : 'Quel confort de maintien vous correspond le mieux&nbsp;?';
      }
      if (progressEl) progressEl.textContent = stepId === 'result' ? '' : (STEP_LABELS[stepId] || '');
    }

    function openModal() {
      resetState();
      showPanel('step1', true);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }

    function renderCard(item, who) {
      if (!item) return '';
      var img = item.image ? '<img src="' + item.image + '" alt="" width="96" height="96" loading="lazy">' : '';
      var whoHtml = who ? '<span class="ps-result-card__who">' + who + '</span>' : '';
      return '<article class="ps-result-card">' +
        '<div class="ps-result-card__img">' + img + '</div>' +
        '<div class="ps-result-card__body">' + whoHtml +
        '<span class="ps-result-card__type">' + (item.type || '') + '</span>' +
        '<h4 class="ps-result-card__title">' + (item.title || '') + '</h4>' +
        '<p class="ps-result-card__desc">' + (item.description || '') + '</p>' +
        '<a class="ps-result-card__link" href="' + item.url + '">Découvrir</a>' +
        '</div></article>';
    }

    function renderResults() {
      var parts = [];
      if (state.choix_couette) parts.push(renderCard(products[state.choix_couette]));
      if (state.statut_lit === 'duo' && state.choix_oreiller_1 && state.choix_oreiller_2) {
        parts.push('<div class="ps-results-pair">' +
          renderCard(products[state.choix_oreiller_1], 'Pour vous') +
          renderCard(products[state.choix_oreiller_2], 'Pour votre partenaire') +
          '</div>');
      } else if (state.choix_oreiller_1) {
        parts.push(renderCard(products[state.choix_oreiller_1]));
      }
      if (resultHeading) resultHeading.textContent = parts.length > 1 ? 'Votre sélection sur-mesure' : 'Votre sélection';
      if (resultSub) resultSub.textContent = 'Voici ce qui correspond à vos nuits.';
      if (resultsEl) resultsEl.innerHTML = parts.join('');
      showPanel('result');
    }

    function afterCouette() {
      if (state.parcours === 'les_deux') showPanel('step5');
      else renderResults();
    }

    function handleAnswer(answer) {
      var active = modal.querySelector('[data-ps-panel].is-active');
      if (!active) return;
      var stepId = active.getAttribute('data-ps-panel');
      if (stepId === 'step1') { state.parcours = answer; showPanel('step2'); return; }
      if (stepId === 'step2') {
        state.statut_lit = answer;
        showPanel(state.parcours === 'oreiller' ? 'step5' : 'step3');
        return;
      }
      if (stepId === 'step3') {
        if (answer === 'synthetic') { state.choix_couette = 'chamonix'; afterCouette(); }
        else showPanel('step4');
        return;
      }
      if (stepId === 'step4') {
        state.choix_couette = answer === 'warm' ? 'megeve' : 'courchevel';
        afterCouette();
        return;
      }
      if (stepId === 'step5') {
        state.choix_oreiller_1 = OREILLER_MAP[answer];
        if (state.statut_lit === 'duo') showPanel('step6');
        else renderResults();
        return;
      }
      if (stepId === 'step6') {
        state.choix_oreiller_2 = OREILLER_MAP[answer];
        renderResults();
      }
    }

    function goBack() {
      var prev = state.history.pop();
      if (!prev) return;
      showPanel(prev, true);
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-ps-close]')) {
        closeModal();
        return;
      }
      var opt = event.target.closest('[data-ps-answer]');
      if (opt) { handleAnswer(opt.getAttribute('data-ps-answer')); return; }
      if (event.target.closest('[data-ps-back]')) { goBack(); return; }
      if (event.target.closest('[data-ps-restart]')) {
        resetState();
        showPanel('step1', true);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeModal();
    });

    modal._open = openModal;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ps-open]');
    if (!trigger) return;
    event.preventDefault();
    var id = trigger.getAttribute('data-ps-open');
    var modal = document.querySelector('[data-ps-modal][data-ps-id="' + id + '"]') ||
      document.querySelector('[data-ps-modal]');
    if (!modal) return;
    initModal(modal);
    modal._open();
  });

  function boot() {
    document.querySelectorAll('[data-lcf-complements]').forEach(initComplements);
    document.querySelectorAll('[data-ps-modal]').forEach(function (modal) {
      if (modal.parentElement !== document.body) initModal(modal);
    });
    observeAlmaWidget();
    syncAlmaAmount(currentCheckoutCents(), true);
    bindMobileAtcDock();
    rewriteEuroPrices();
    setTimeout(rewriteEuroPrices, 80);
    setTimeout(function () { observeAlmaWidget(); syncAlmaAmount(currentCheckoutCents(), true); }, 500);
    setTimeout(function () { syncAlmaAmount(currentCheckoutCents(), true); }, 1400);
    setTimeout(function () { syncAlmaAmount(currentCheckoutCents(), true); }, 2800);
  }

  document.addEventListener('product:rerender', function () {
    setTimeout(function () {
      document.querySelectorAll('[data-lcf-complements]').forEach(function (box) {
        if (box.dataset.ready === 'true') return;
        initComplements(box);
      });
      document.querySelectorAll('[data-lcf-complements]').forEach(updateAtcPrice);
      rewriteEuroPrices();
      observeAlmaWidget();
      syncAlmaAmount(currentCheckoutCents(), true);
      bindMobileAtcDock();
    }, 0);
  }, true);

  var atcDockBound = false;

  function bindMobileAtcDock() {
    if (atcDockBound) return;
    if (!document.querySelector('.product--immersive')) return;
    atcDockBound = true;

    var mq = window.matchMedia('(max-width: 999px)');
    var spacer = document.createElement('div');
    spacer.setAttribute('data-lcf-atc-spacer', '');
    spacer.setAttribute('aria-hidden', 'true');
    var ticking = false;

    function atcBlock() {
      return document.querySelector('.product--immersive [data-block-type="buy-buttons"]');
    }

    function undock() {
      var atc = atcBlock();
      document.body.classList.remove('lcf-atc-docked');
      if (atc) atc.classList.remove('is-docked');
      spacer.style.height = '0px';
      if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
    }

    function dock(atc) {
      if (!atc.classList.contains('is-docked')) {
        spacer.style.height = atc.offsetHeight + 'px';
        if (atc.parentNode) atc.parentNode.insertBefore(spacer, atc.nextSibling);
        atc.classList.add('is-docked');
        document.body.classList.add('lcf-atc-docked');
      } else {
        spacer.style.height = atc.offsetHeight + 'px';
      }
    }

    function tick() {
      ticking = false;
      var atc = atcBlock();
      if (!atc || !mq.matches) {
        undock();
        return;
      }

      var marker = spacer.parentNode ? spacer : atc;
      var rect = marker.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var barH = atc.offsetHeight || 56;
      var scrolled = (window.scrollY || document.documentElement.scrollTop || 0) > 12;
      var passed = rect.bottom < 1;
      var slotInView = rect.top <= vh - barH + 8;

      if (!scrolled) {
        document.body.classList.remove('lcf-atc-passed');
        undock();
        return;
      }

      if (passed) {
        undock();
        document.body.classList.add('lcf-atc-passed');
        var qa = document.querySelector('.product-quick-add--immersive');
        if (qa) qa.classList.add('is-visible');
        return;
      }

      document.body.classList.remove('lcf-atc-passed');

      if (slotInView) {
        undock();
        return;
      }

      dock(atc);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (mq.addEventListener) mq.addEventListener('change', tick);
    else if (mq.addListener) mq.addListener(tick);
    document.addEventListener('product:rerender', function () {
      window.requestAnimationFrame(tick);
    }, true);
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
